import React from "react";
import { AspectRatio, SimpleGrid } from "@chakra-ui/react";
import { ResourceCard } from "components/resource-card";
import Image from "next/image";
import { useWarehouseCdp } from "contexts/warehouse-cdp-context";
import { Section } from "components/section";
import { TextTitle } from "ui/text";
import Balancer from "react-wrap-balancer";

export function WarehouseResources() {
  const { warehouse } = useWarehouseCdp();

  if (!warehouse.resources || warehouse.resources.length === 0) {
    return null;
  }

  return (
    <Section>
      <TextTitle size="lg" align="center" title={<Balancer>Learn more about {warehouse.name} CDP</Balancer>} />

      <SimpleGrid
        columns={{ base: 1, md: 2, lg: 4 }}
        gap="small"
        justifyItems="center"
        mt={{ base: "biggest", lg: "huge" }}
      >
        {warehouse.resources.map((resource) => (
          <ResourceCard
            key={resource.title}
            maxW={{ base: "cardMaxW", md: "100%" }}
            href={resource.href}
            target="_blank"
            title={resource.title}
            titleAs="h3"
            image={
              <AspectRatio ratio={2 / 1} width="100%">
                <Image
                  fill
                  src={`${resource.imageSrc}?w=800`}
                  alt={resource.imageAlt}
                  sizes="100%"
                  style={{ objectFit: "cover" }}
                />
              </AspectRatio>
            }
          />
        ))}
      </SimpleGrid>
    </Section>
  );
}
